module.exports = __webpack_public_path__ + "static/media/Star.2428f20e.svg";